import { loadEpic } from './state/load.epic';

export const teamschatSummaryEpics = [loadEpic];
